import { Box, Typography } from "@mui/material";
import { useCountdownTimer } from "../../../customHooks/useCountdownTimer";
import theme from "../../../theme";
import { useTranslation } from "react-i18next";

const TimeLeft = ({ data }) => {

  const { t } = useTranslation("timeLeft");

  const { countDown, isInitialised } = useCountdownTimer({
    seconds: Math.floor(data?.seconds || 0),
  });

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.main}`,
        textAlign: 'center',
        borderRadius: '0.75rem', // 12px
        paddingTop: '1rem', // 16px
        paddingBottom: '1rem',
        paddingLeft: '0.5rem', // 8px
        paddingRight: '0.5rem',
      }}
    >
      {data?.seconds > 0 && (countDown?.hours > 0 || countDown?.minutes > 0 || countDown?.seconds > 0) && isInitialised ? (
        <Typography
          fontWeight={600}
          fontSize="1.1rem"
          sx={{
            color: theme.palette.text.secondary,
          }}
        >
          {t("Time Left")}
        </Typography>
      ) : null}
      <Typography
        fontWeight={500}
        fontSize="1rem"
        marginTop="0.25rem"
        sx={{
          color: theme.palette.text.secondary,
        }}
      >
        {!isInitialised && (countDown?.hours === 0 && countDown?.minutes === 0 && countDown?.seconds === 0) ? (
          <span style={{ fontWeight: 700, color: theme.palette.text.secondary }}>
            {t("Loading...")}
          </span>
        ) : data?.seconds && (countDown?.hours > 0 || countDown?.minutes > 0 || countDown?.seconds > 0) ? (
          <>
            <span style={{ fontWeight: 800, color: theme.palette.text.secondary }}>
              {`${countDown?.hours < 10 ? `0${countDown?.hours}` : countDown?.hours}`}
            </span>{' '}
            {t("hours")}{' '}
            <span style={{ fontWeight: 800, color: theme.palette.text.secondary }}>
              {`${countDown?.minutes < 10 ? `0${countDown?.minutes}` : countDown?.minutes}`}
            </span>{' '}
            {t("mins")}{' '}
            <span style={{ fontWeight: 800, color: theme.palette.text.secondary }}>
              {`${countDown?.seconds < 10 ? `0${countDown?.seconds}` : countDown?.seconds}`}
            </span>{' '}
            {t("sec")}
          </>
        ) : (
          <span style={{ fontWeight: 700, color: theme.palette.background.paper }}>
            {t("Time's up")}
          </span>
        )}
      </Typography>
    </Box>
  );
};

export default TimeLeft;